import group from './group';
import updateSelection from './updateSelection';

const updateSelectionAndGroup = (canvasState, command) => {
    const updatedCanvasState = updateSelection(canvasState, command);
    return group(updatedCanvasState);
};

export default updateSelectionAndGroup;
